import { Dispatch, SetStateAction, useEffect } from 'react';

import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { PermissoesModulosChip } from 'pages/cadastro/permissoes/components/form/modulos/PermissoesModulosChip';
import { PermissoesProps } from 'pages/cadastro/permissoes/types';
import { getEnabledCount } from 'pages/cadastro/permissoes/utils';

export function PermissoesModulosAutocomplete({
    setSelectedModuleId,
    setPermSearch,
    selectedModuleId,
}: {
    setSelectedModuleId: Dispatch<SetStateAction<number | null>>;
    setPermSearch: Dispatch<SetStateAction<string>>;
    selectedModuleId: number | null;
}) {
    const { values } = useFormikContext<PermissoesProps>();
    const modules = values.grupoUsuarioRecursoPermissoes || [];

    useEffect(() => {
        if (modules.length > 0 && selectedModuleId === null) {
            setSelectedModuleId(modules[0].idRecurso);
        }
    }, [modules, selectedModuleId]);

    const selectedModuleIndex = modules.findIndex((m) => m.idRecurso === selectedModuleId);
    const selectedModule = modules[selectedModuleIndex];

    return (
        <Autocomplete
            disableClearable
            options={modules}
            getOptionLabel={(option) => option.text}
            value={selectedModule || null}
            onChange={(_, newValue) => {
                if (newValue) {
                    setSelectedModuleId(newValue.idRecurso);
                    setPermSearch('');
                }
            }}
            renderInput={(params) => <TextField {...params} size="small" label="Módulo" />}
            renderOption={(props, option) => {
                const enabled = getEnabledCount(option);
                const total = option.permissoes.length;
                return (
                    <li {...props}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                            <Typography variant="body2">{option.text}</Typography>

                            <PermissoesModulosChip
                                label={enabled}
                                status={enabled === 0 ? 'none' : enabled === total ? 'all' : 'partial'}
                                sx={{ ml: 1 }}
                            />
                        </Box>
                    </li>
                );
            }}
        />
    );
}
